import React from "react";
import RemoveCircleOutline from "@mui/icons-material/RemoveCircleOutline";
import { checkedCircleIconSmall } from "./checkedCircleIcon";
import { cancelIconRedSmall } from "./cancelIconRed";

export const unknownCircleIconSmall = (
  <RemoveCircleOutline
    color="disabled"
    fontSize="small"
    titleAccess="No data yet"
  />
);

/**
 * Green check for true, red X for false, grey dash when the backend has no
 * data (null/undefined) — e.g. a camera whose analytics have never run
 * (CHM-only site or freshly onboarded camera). Rendering "no data" as a red
 * X was misleading (ENG-920).
 */
export const triStateIcon = (value: boolean | null | undefined) =>
  value === null || value === undefined
    ? unknownCircleIconSmall
    : value
    ? checkedCircleIconSmall
    : cancelIconRedSmall;
